"use strict";import"./core.js";import{Theme as e}from"./src/Theme.js";import t from"./src/theme-lightest.css.js";e.registerThemeFragment("lightest","color",t);
//# sourceMappingURL=theme-lightest.js.map
